<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="340px"
    class="member-limit-dialog-box "
    :closable="false"
    :footer="null"
    :mask-closable="false"
    @cancel="TipDialogVisible=false"
  >
    <div
      v-if="!strutctureStatus"
      class="dialog-tip-box dd-qw-tip-dia-box"
    >
      <i class="icon iconfont iconicon-test68" />
      <h2>{{ orgReplace[0] }}{{ typeTxt }}{{ orgReplace[1] }}</h2>
      <div class="d-tip-con">
        <span class="ddqw-t-tip">{{ tisp[0] }}</span>{{ tisp[1] }}
      </div>
      <div class="limit-btn-box">
        <a-button
          type="primary"
          @click="triggerTransfer('transfer')"
        >
          {{ $t('message["466"]') }}
        </a-button>
        <a-button
          @click="TipDialogVisible=false"
        >
          {{ $t('message["896"]') }}
        </a-button>
      </div>
    </div>
    <div
      v-else-if="strutctureStatus === 2"
      class="dialog-tip-box dd-qw-tip-dia-box"
    >
      <a-spin :tip="`${spinTip[0]}${typeTxt}${spinTip[1]}…`" />
    </div>
    <div
      v-else-if="strutctureStatus === 1"
      class="dialog-tip-box dd-qw-tip-dia-box"
    >
      <i class="icon iconfont iconicon-test33" />
      <h2>{{ $t('message["1219"]') }}</h2>
      <div
        class="limit-btn-box"
        style="margin-top:16px;"
      >
        <a-button
          type="primary"
          @click="reloadHandler"
        >
          {{ $t('message["915"]') }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    typeTxt: {
      type: String,
      default: ''
    },
    orgItemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      TipDialogVisible: false,
      submiting: false
    }
  },
  computed: {
    ...mapState('organization/person', ['datas', 'strutctureStatus']),
    cId () {
      return this.orgItemData.cid
    },
    tisp () {
      return this.$t('message["335"]').split('|')
    },
    orgReplace () {
      return this.$t('message["1188"]').split('|')
    },
    spinTip () {
      return this.$t('message["1585"]').split('|')
    }
  },
  methods: {
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    },
    triggerTransfer (val) {
      this.$emit('triggerMethod', val)
      // this.TipDialogVisible = false
    },
    reloadHandler () {
      this.TipDialogVisible = false
      location.reload()
    }
  }
}
</script>
<style lang="scss" scoped>
.dd-qw-tip-dia-box::v-deep {
  .iconicon-test68, .ddqw-t-tip {
    color: #F57676;
  }
  .ant-spin-text {
    color: #333;
  }
  .iconicon-test33 {
    color: #42C27E;
    font-size: 21px;
    position: absolute;
    left: 0;
  }
}
</style>
